import { axios } from "@cores/axiosWrapper";

/**
 * Automated Workflow 목록 조회.
 * @param {string} stageId - 스테이지 ID
 * @param {string} apiEndpoint - API 엔드포인트
 * @param {string} projectId - 프로젝트 ID
 * @param {object} params - { name, statuses, limit, nextToken }
 *   - name: 워크플로우 이름 검색(서버)
 *   - statuses: DRAFT,ACTIVE,INACTIVE 중 콤마 구분 다중
 *   - limit, nextToken: 토큰 기반 페이지네이션
 */
export const getAutomatedWorkflowsAPI = (stageId, apiEndpoint, projectId, params = {}) => {
    return axios.get(`${apiEndpoint}/automated-workflows`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
};

/**
 * Automated Workflow 생성.
 * @param {string} stageId - 스테이지 ID
 * @param {string} apiEndpoint - 스테이지 API endpoint
 * @param {string} projectId - 프로젝트 ID(헤더)
 * @param {object} data - { name, description }
 */
export const createAutomatedWorkflowAPI = (stageId, apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/automated-workflows`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
};
